"use client";

import React from "react";
import { HydrationBoundary, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ThemeProvider } from "next-themes";

import { TooltipProvider } from "@/components/ui/tooltip-new";
import { RegistrationProvider } from "../components/RegistrationContext";
import { AuthProvider } from "../context/AuthContext";
import { TivionOrgProvider } from "../components/TivionOrgContext";

export default function Providers({ children, dehydratedState }) {
  const [queryClient] = React.useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            refetchOnmount: false,
            refetchOnReconnect: false,
            retry: false,
          },
        },
      })
  );

  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem
      disableTransitionOnChange
    >
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RegistrationProvider>
            <TivionOrgProvider>
              <TooltipProvider delayDuration={200}>
                <HydrationBoundary state={dehydratedState}>
                  {children}
                </HydrationBoundary>
              </TooltipProvider>
              <ReactQueryDevtools initialIsOpen={false} />
            </TivionOrgProvider>
          </RegistrationProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
